import type { IDisplaySection } from "@lexicanon/shared"
import { Badge, Group } from "@mantine/core"
import { useProduct } from "../../../lib/tenant"
import { SectionHeader } from "./SectionHeader"

interface IProps {
  section: IDisplaySection
  data: unknown
}

export function BadgesSection({ section, data }: IProps): React.ReactElement | null {
  const product = useProduct()
  if (!Array.isArray(data) || data.length === 0) return null

  return (
    <div>
      <SectionHeader id={section.id} label={section.label} />
      <Group gap="xs">
        {data.map((item) => (
          <Badge
            key={`${section.id}-${typeof item === "string" ? item : String(item)}`}
            variant={product === "lexicanon" ? "filled" : "light"}
            color="brand"
            size={product === "lexicanon" ? "sm" : "md"}
          >
            {typeof item === "string" ? item : String(item)}
          </Badge>
        ))}
      </Group>
    </div>
  )
}
